// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
import { isNumberArray } from "./is-array.js";
/** Test if two arrays are deep equal, with a length limit that defaults to 16 */
export function arrayEqual(a, b, limit = 16) {
    if (a !== b) {
        return false;
    }
    const arrayA = a;
    const arrayB = b;
    if (!isNumberArray(arrayA)) {
        return false;
    }
    if (isNumberArray(arrayB) && arrayA.length === arrayB.length) {
        for (let i = 0; i < arrayA.length; ++i) {
            if (arrayB[i] !== arrayA[i]) {
                return false;
            }
        }
    }
    return true;
}
/** Copy a value */
export function arrayCopy(a) {
    if (isNumberArray(a)) {
        return a.slice();
    }
    return a;
}
//# sourceMappingURL=array-equal.js.map